export const initialCribs: CribModel[] = [
    {
        cribCode: "001",
        description: "Tool Room 1",
    }
]